import { ArrowLeft } from 'lucide-react';
import { Button } from '@/shared/components';
import { CommunicationConflict } from './CommunicationConflict';
import type { SaveFailure } from './EditorSaveBar';

export interface MobileSaveState {
  editable: boolean;
  dirty: boolean;
  saving: boolean;
  /** Ein Schalter wird gerade gespeichert — beide gehen gegen dieselbe Revision. */
  blocked: boolean;
  conflict: boolean;
  reloadFailed: boolean;
  failure: SaveFailure | null;
  onDiscard: () => void;
  onSave: () => void;
  onReload: () => void;
  onClose: () => void;
}

/**
 * Fuß des Vollbild-Editors. Leiste und Konflikt-Banner der Seite liegen hinter dem Sheet, also muss
 * hier ankommen, was sie sonst zeigen: Grund, Sprung zum Feld und das Laden nach einem Konflikt.
 */
export function MobileEditorFooter({
  state,
  previewing,
  onBack,
  onJump,
}: {
  state: MobileSaveState;
  previewing: boolean;
  onBack: () => void;
  onJump: () => void;
}) {
  if (previewing) {
    return (
      <Button
        type="button"
        variant="primary"
        className="min-h-12 w-full"
        leftIcon={<ArrowLeft className="size-4" />}
        onClick={onBack}
      >
        Zurück zum Text
      </Button>
    );
  }
  if (state.conflict) {
    return (
      <CommunicationConflict
        dirty={state.dirty}
        reloadFailed={state.reloadFailed}
        onReload={state.onReload}
      />
    );
  }
  if (!state.editable) {
    return (
      <Button type="button" variant="primary" className="min-h-12 w-full" onClick={state.onClose}>
        Schließen
      </Button>
    );
  }
  return (
    <div className="w-full space-y-2">
      {state.failure && (
        <p role="alert" className="text-sealwax flex flex-wrap items-center gap-x-2 text-xs">
          <span>
            {state.failure.title} – {state.failure.message}
          </span>
          {state.failure.onJump && (
            <button
              type="button"
              onClick={onJump}
              className="text-ink focus-visible:outline-sage min-h-11 px-1 font-semibold underline underline-offset-2 focus-visible:outline focus-visible:outline-2"
            >
              Zum Feld
            </button>
          )}
        </p>
      )}
      <div className="grid grid-cols-[1fr_1.4fr] gap-2">
        <Button
          type="button"
          variant="ghost"
          className="border-line min-h-12 border"
          disabled={!state.dirty || state.saving}
          onClick={state.onDiscard}
        >
          Verwerfen
        </Button>
        <Button
          type="button"
          variant="brand"
          className="min-h-12"
          loading={state.saving}
          disabled={!state.dirty || state.blocked}
          onClick={state.onSave}
        >
          Speichern
        </Button>
      </div>
    </div>
  );
}
